import firebase from 'firebase/app'
import { firebaseStateReducer, reactReduxFirebase } from 'react-redux-firebase'
import { routerMiddleware, routerReducer, push } from 'react-router-redux'
import { combineReducers } from 'redux'
import { configureStore } from 'redux-starter-kit'
import history from 'Root/history'
import { alertReducer } from './actions/alerts'
import { boardReducer } from './actions/boards'
import { historyReducer } from './actions/history'
import { queueReducer } from './actions/queue'
import { selectedBlocksReducer } from './actions/selectedBlocks'
import { shareReducer } from './actions/share'
import { sidebarReducer } from './actions/sidebar'
import { togglesReducer } from './actions/toggles'
import { uploadReducer } from './actions/upload'
import { appReducer } from './actions/app'
import { discussReducer } from './actions/discuss'
import { activityReducer } from './actions/activity'
import thunk from 'redux-thunk'

const rootReducer = combineReducers({
  firebase: firebaseStateReducer,
  app: appReducer,
  alerts: alertReducer,
  activity: activityReducer,
  sidebar: sidebarReducer,
  share: shareReducer,
  toggles: togglesReducer,
  uploads: uploadReducer,
  board: boardReducer,
  selectedBlocks: selectedBlocksReducer,
  queue: queueReducer,
  discuss: discussReducer,
  history: historyReducer,
  router: routerReducer
})

const store = configureStore({
  reducer: rootReducer,
  middleware: [
    thunk,
    // ...getDefaultMiddleware(),
    routerMiddleware(history)
  ],
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: {},
  enhancers: []
})

window.go = url => store.dispatch(push(url))

const reactReduxFirebaseWrap = store =>
  reactReduxFirebase(firebase, {
    userProfile: 'users',
    attachAuthIsReady: true,
    logErrors: process.env.NODE_ENV === 'development'
  })(() => store)

export default reactReduxFirebaseWrap(store)()
